var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShowAll = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5H15V16.5H3V1.5ZM1.5 1.5C1.5 0.671539 2.17163 0 3 0H15C15.8284 0 16.5 0.671539 16.5 1.5V16.5C16.5 17.3285 15.8284 18 15 18H3C2.17163 18 1.5 17.3285 1.5 16.5V1.5ZM6 21C5.17163 21 4.5 20.3285 4.5 19.5H6H18V4.5V3C18.8284 3 19.5 3.67154 19.5 4.5V19.5C19.5 20.3285 18.8284 21 18 21H6ZM7.5 22.5C7.5 23.3285 8.17163 24 9 24H21C21.8284 24 22.5 23.3285 22.5 22.5V7.5C22.5 6.67154 21.8284 6 21 6V7.5V22.5H9H7.5ZM5.25 3C4.83579 3 4.5 3.33579 4.5 3.75C4.5 4.16421 4.83579 4.5 5.25 4.5H12.75C13.1642 4.5 13.5 4.16421 13.5 3.75C13.5 3.33579 13.1642 3 12.75 3H5.25ZM4.5 6.75C4.5 6.33579 4.83579 6 5.25 6H9.75C10.1642 6 10.5 6.33579 10.5 6.75C10.5 7.16421 10.1642 7.5 9.75 7.5H5.25C4.83579 7.5 4.5 7.16421 4.5 6.75ZM11.85 10.95C12.0985 10.6186 12.0314 10.1485 11.7 9.89995C11.3686 9.65142 10.8985 9.71858 10.65 10.05L8.82568 12.4824L7.16601 11.3759C6.82137 11.1462 6.35572 11.2393 6.12595 11.5839L4.62595 13.8339C4.39619 14.1786 4.48932 14.6442 4.83396 14.874C5.17861 15.1038 5.64426 15.0106 5.87403 14.666L6.958 13.04L8.58396 14.124C8.91516 14.3448 9.36116 14.2684 9.59999 13.95L11.85 10.95Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShowAll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/show-all.2e8f4cdd916427dc0fa7fc7ab87e0eef.svg";